import { render, staticRenderFns } from "./DetailTrain.vue?vue&type=template&id=0376a916&scoped=true"
import script from "./DetailTrain.vue?vue&type=script&lang=js"
export * from "./DetailTrain.vue?vue&type=script&lang=js"
import style0 from "./DetailTrain.vue?vue&type=style&index=0&id=0376a916&prod&lang=scss"
import style1 from "./DetailTrain.vue?vue&type=style&index=1&id=0376a916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0376a916",
  null
  
)

export default component.exports